<template>
  <div>
    <download-excel
      style="width: 100px"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="兑换订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.userUid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="isReceive" slot-scope="text, isReceive">
        <span>{{ isReceive.isReceive === 0 ? "否" : "是" }}</span>
        <!-- <span v-else>{{
          isReceive.isReceive === 1 ? "领取" : "qu"
        }}</span> -->
      </template>
      <template slot="orderStatus" slot-scope="text, orderStatus">
        <span v-if="orderStatus.orderStatus === 0">待领取</span>
        <span v-else>{{
          orderStatus.orderStatus === 2 ? "确认领取" : "取消领取"
        }}</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <span v-if="operate.orderStatus === 2">
          <a
            class="test"
            href="javascript:;"
            v-on:click.prevent="
              topage(`/home/exchangeOrderDetailsTwo?orderNo=${operate.orderNo}`)
            "
            >订单详情</a
          >
        </span>
        <span v-else>
          <a
            href=""
            v-on:click.prevent="
              topage(`/home/exchangeOrderDetailsTwo?orderNo=${operate.orderNo}`)
            "
            >订单详情</a
          >
          <a href="javascript:;" v-if="operate.orderStatus === 0" @click="exchangeok(operate)">确认领取</a>
          <a href="javascript:;" v-if="operate.orderStatus === 0" @click="exchangeno(operate)">取消订单</a>
        </span>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeExchange,
  storeExchangeTrue,
  storeExchangeFalse,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "orderNo",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "用户昵称",
    dataIndex: "userName",
    align: "center",
  },
  {
    title: "用户手机号码",
    dataIndex: "userPhone",
    align: "center",
  },
  {
    title: "支付彩票",
    dataIndex: "payLottery",
    align: "center",
    scopedSlots: { customRender: "payLottery" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "是否领取",
    dataIndex: "isReceive",
    align: "center",
    scopedSlots: { customRender: "isReceive" },
  },
  {
    title: "订单状态",
    dataIndex: "orderStatus",
    scopedSlots: { customRender: "orderStatus" },
  },
  {
    title: "支付时间",
    dataIndex: "createTime",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        编号: "orderNo",
        用户呢称: "userName",
        用户手机号码: "userPhone",
        支付彩票: "payLottery",
        所属门店: "shopName",
        是否领取: "isReceive",
        订单状态: "areaId",
        支付时间: "name",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getStoreExchangeList();
  },
  props: ["formInline"],
  methods: {
    async startDownload(){
      this.loading = true;
      let p = this.formInline;
      p.page = 1;
      p.limit = 10000;
      await storeExchange(p).then(
        (res) => {
          this.data1 = res.data;
          this.loading = false;
        }
      );
      return this.data1;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      this.formInline.page = this.pagination.current;
      storeExchange(this.formInline).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
    },
    // 确认领取
    exchangeok(row) {
      console.log(row);
      this.loading = true;
      storeExchangeTrue({ orderNo: row.orderNo, orderStatus: 2 }).then(
        (res) => {
          this.loading = false;
          this.getStoreExchangeList();
          if (!res.success) {
            message.error(res.info);
          } else {
            message.success(res.data);
          }
        }
      );
    },
    // 取消领取
    exchangeno(row) {
      this.loading = true;
      storeExchangeFalse({ orderNo: row.orderNo, orderStatus: 1 }).then(
        (res) => {
          this.loading = false;
          this.getStoreExchangeList();
          if (!res.success) {
            message.error(res.info);
          } else {
            message.success(res.data);
          }
        }
      );
    },
    // 分页数据
    getStoreExchangeList() {
      storeExchange({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    seach() {
      this.loading = true;
      if (this.formInline.orderNo === "") {
        // message.warning("订单编号不能为空");
      }
      this.pagination.current = 1;
      storeExchange(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/exchangeOrderHomeContentTwo.vue